import React from 'react';
import {OrdersListUIProvider} from "./OrdersListUIContext";
import {OrdersListCard} from "./OrdersListCard";

export function OrdersListPage({history}) {
    const ordersListUIEvents = {
        openViewOrderPage: (id) => {
            history.push(`/reports/orders/${id}`)
        }
    }

    return (
        <OrdersListUIProvider ordersListUIEvents={ordersListUIEvents}>
            <OrdersListCard/>
        </OrdersListUIProvider>
    )
}